// Note: Using hardcoded Bearer token for this cluster
// import { getHost, getTokenService } from "../utils/tokenService";
import { getCachedToken, getHost } from '../../utils/tokenService';
import { SEARCH_METADATA_API_ENDPOINT } from '../../constants';
import { apiJson } from './api-jsons';

const fetchAnswersList = async () => {
  try {
    const token = await getCachedToken();

    const response = await fetch(`${getHost()}${SEARCH_METADATA_API_ENDPOINT}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ...apiJson,
        metadata: [
          {
            type: 'ANSWER',
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    const answers = data.map((answer: any) => ({
      id: answer.metadata_id,
      name: answer.metadata_name,
      description: answer.metadata_header?.description || '',
    }));

    return {
      objects: answers,
    };
  } catch (error) {
    return {
      objects: [],
    };
  }
};

export default fetchAnswersList;

const fetchAnswersListWithSearch = async (search: string) => {
  try {
    const token = await getCachedToken();

    const response = await fetch(`${getHost()}${SEARCH_METADATA_API_ENDPOINT}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ...apiJson,
        metadata: [
          {
            type: 'ANSWER',
            name_pattern: search.trim(),
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    const answers = data.map((answer: any) => ({
      id: answer.metadata_id,
      name: answer.metadata_name,
      description: answer.metadata_header?.description || '',
    }));

    return {
      objects: answers,
    };
  } catch (error) {
    return {
      objects: [],
    };
  }
};

export { fetchAnswersList, fetchAnswersListWithSearch };
